/**
 * Espelho de `TipoIdentificadorCodigoCompostoProdutoEnum` (ATS.Hub.Lib.Shared): o que vem embutido
 * num código composto EAN + lote/série (`CodigoCompostoResolvidoStruct.tipoIdentificador`).
 */
export enum TipoIdentificadorCodigoCompostoProdutoEnum {
    Lote = 1,
    Serie = 2,
}
